import React from 'react';
import { redirect } from 'react-router-dom';
import { g_Auth } from '../apis/apiAuth';
import { updateUserTokenAsync } from '../stores/UserStore';
import { setLoginRedirectPath } from '../stores/NavigationStore';

// /////////////////////////////////////////////////////////////////////////////////////////////////
export async function protectedLoader(props={}) {
  const { request, store } = props;
  console.log(props);
  // If the user is not logged in and tries to access `/protected`, we redirect
  // them to `/login` with a `from` parameter that allows login to redirect back
  // to this page upon successful authentication
  const state = store.getState();
  const token = state?.user?.token;
  if (!token) {
    console.warn('protectedLoader', 'Not Authenticated!');
    // We could get here due to user refreshing the browser window, in that case
    // we can retry populating g_Auth using server enpoint with our cookie
    const fromPath = new URL(request.url).pathname;
    store.dispatch(setLoginRedirectPath(fromPath)); // Store the intended path in Redux!
    let params = new URLSearchParams();
    params.set('from', fromPath);

    const replyJson = await g_Auth.authCookieMirror().catch((err) => {
      console.error('authCookieMirror', err);
    });
    
    if (replyJson) {
      console.log('replyJson', replyJson);
      const result = await store.dispatch(updateUserTokenAsync(replyJson.token));
      if (result?.meta?.requestStatus === 'fulfilled') {
        return null; // proceed
      }
      return redirect('/login?' + params.toString()); // Token invalid -> treat as unauthenticated
    } else {
      console.log('No replyJson');
      return redirect('/login?' + params.toString());
    }
  } else {
    return null;
  }
}
